import { action } from "typesafe-actions";
import { IDataTableV2DateState } from "../../components/TableV2/preDefinedPlugins/DataTableV2Date/DataTableV2Date.types";
import { IDatatableV2AdvancedSearchFilter } from "../../components/TableV2/preDefinedPlugins/SearchFilter/SearchFilter.types";
import { ThunkAction } from "redux-thunk";
import { IStoreState } from "../initialStoreState";
import { AnyAction } from "redux";
import {
  saveLoaderCompleted,
  saveLoaderProgress,
  showMessage,
} from "../messages/messagesActions";
import { api } from "../../api/api";
import { IIntent } from "./Intents.types";

export const FETCH_INTENTS_LIST_PROGRESS = "FETCH_INTENTS_LIST_PROGRESS";
export const FETCH_INTENTS_LIST_SUCCESS = "FETCH_INTENTS_LIST_SUCCESS";
export const FETCH_INTENTS_LIST_FAILED = "FETCH_INTENTS_LIST_FAILED";

export const fetchIntentsListProgress = () =>
  action(FETCH_INTENTS_LIST_PROGRESS);
export const fetchIntentsListSuccess = (
  data: IIntent[],
  totalRecords: number,
) => action(FETCH_INTENTS_LIST_SUCCESS, { data, totalRecords });
export const fetchIntentsListFailed = () => action(FETCH_INTENTS_LIST_FAILED);

export const fetchIntentsListAsync =
  (
    companyOutletUuid: string,
    pageNumber: number,
    itemPerPage: number,
    pageLimit: number,
    status: string,
    date: IDataTableV2DateState["dates"],
    searchValue?: IDatatableV2AdvancedSearchFilter,
    searchByIntent?: string,
    intentUuid?: string,
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    dispatch(fetchIntentsListProgress());
    try {
      dispatch(saveLoaderProgress());
      let searchQuery = "";

      if (searchByIntent) {
        searchQuery += `&intent=${searchByIntent}`;
      }

      if (intentUuid) {
        searchQuery += `&intent_uuid=${intentUuid}`;
      }

      if (searchValue?.length ?? 0) {
        const advanceFilter = [...(searchValue || [])];
        searchQuery += `&advanceFilter=${JSON.stringify(advanceFilter)}`;
      }

      searchQuery += `&from_date=${date.fromDate}&to_date=${date.toDate}`;

      if (status && status !== "-1") {
        searchQuery += `&status=${status}`;
      }

      const response = await api.get(
        `/genai/get-intents?company_outlet_uuid=${companyOutletUuid}&pageNo=${pageNumber}&pageLimit=${pageLimit}&itemPerPage=${itemPerPage}` +
          searchQuery,
      );
      const data: IIntent[] = response.data.data || [];

      const totalRecords = response.data.totalRecords || 0;
      dispatch(fetchIntentsListSuccess(data, totalRecords));
    } catch (error) {
      dispatch(fetchIntentsListFailed());
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

export const upsertIntent =
  (data: IIntent, onCallback?: (isSuccess: boolean, data?: IIntent) => void) =>
  async (dispatch: any) => {
    try {
      dispatch(saveLoaderProgress());
      const response = await api.post("/genai/upsert-intent", data);
      dispatch(saveLoaderCompleted());
      dispatch(
        showMessage({
          type: "success",
          message: data.intent_uuid
            ? "Intent updated successfully"
            : "Intent created successfully",
          displayAs: "snackbar",
        }),
      );
      onCallback?.(true, response.data);
      return response.data;
    } catch (error: any) {
      onCallback?.(false);
      dispatch(saveLoaderCompleted());
      dispatch(
        showMessage({
          type: "error",
          message: error.response?.data?.message || "Failed to save intent",
          displayAs: "snackbar",
        }),
      );
    }
  };

export const CLEAR_INTENTS_STATE = "CLEAR_INTENTS_STATE";
export const clearIntentsState = () => action(CLEAR_INTENTS_STATE);
